import { msg } from '@lingui/core/macro';
import { ShieldAlert } from 'lucide-react';
import { lazy, Suspense, useState } from 'react';

import type { PersonFraudRecordProps } from './person-fraud-record.types';

// Porta do "Registrar fraude" (unidade 8X) para Pessoas e para a Operação de crédito: leve de propósito. O
// formulário de três passos e o fio só carregam na primeira abertura (import dinâmico), como o cadastro rápido.
// Dado de fraude e PLD: só por ação humana, com prévia; o agente não registra fraude.

export type { PersonFraudRecordProps } from './person-fraud-record.types';

/** O botão da barra, igual nas duas telas: rótulo do legado e o ícone de escudo. */
export const PERSON_FRAUD_ACTION = { label: msg`Registrar fraude`, icon: ShieldAlert } as const;

const Sheet = lazy(() => import('./screens/person-fraud-record-sheet').then((module) => ({ default: module.PersonFraudRecordSheet })));

/** O formulário de três passos do legado (`FraudRecordContainer`) num painel lateral, com a prévia antes do envio. */
export function PersonFraudRecord(props: PersonFraudRecordProps) {
  const [used, setUsed] = useState(props.open);
  if (props.open && !used) setUsed(true);
  if (!used) return null;
  return (
    <Suspense fallback={null}>
      <Sheet {...props} />
    </Suspense>
  );
}
